(function() {
    
    // add class "no-hero-image" if page has no image in the top
    // it needs to style breadcrumbs
    
    window.addEventListener('DOMContentLoaded', () => {
        const heroImages = document.querySelectorAll('#content [class*="hero"]');
        if (heroImages.length === 0) {
            document.querySelector("body").setAttribute("class", "no-hero-image");
        }    
    });
    
})();